import React from 'react';
import HostContent from '../content/HostContent';
import {useHost} from '../../../api/hooks';
import Loader from '../Loader';
import PageNotFound from '../PageNotFound';
import Error from '../Error';

export const HostSelector = ({match, children}) => {
    const {data: host, isLoading, error} = useHost(match.params.id);

    if (isLoading) {
        return <Loader />;
    }

    if (error) {
        return <Error errors={[error]} />;
    }

    return children({host});
};

const Host = ({match}) => (
    <HostSelector match={match}>
        {({host}) => (
            <>
                {host.error || host.node ? <PageNotFound error={host} />
                    :
                    <>
                        <HostContent host={host} />
                    </>
                }
            </>
        )}
    </HostSelector>
);

export default Host;
